import { render, staticRenderFns } from "./MessageRegisterComplete.vue?vue&type=template&id=21fdf92f&lang=pug"
import script from "./MessageRegisterComplete.vue?vue&type=script&lang=ts"
export * from "./MessageRegisterComplete.vue?vue&type=script&lang=ts"
import style0 from "./MessageRegisterComplete.vue?vue&type=style&index=0&id=21fdf92f&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports